import { Component, Inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { finalize } from "rxjs/operators";
import { EscritorioService } from "app/empreendimento/services/escritorio.service";
import { BaseComponent } from "../../base-module/base-component/base.component";
import { RolesService } from "../services/roles.service";

export interface DialogData {
    id?: number;
    name?: string;
    escritorio_id?: number;
    role_id?: number;
    show_roles?: boolean;
}

interface IRole {
    id: number;
    name: string;
}

interface IEscritorio {
    id: number;
    nome_fantasia: string;
}

@Component({
    selector: "dialog-ffiltrar-usuarios",
    templateUrl: "./filtrar-usuarios.component.html",
    styleUrls: ["./filtrar-usuarios.component.scss"],
    providers: [EscritorioService],
})
export class FiltrarUsuariosComponent extends BaseComponent implements OnInit {
    name!: FormControl;
    escritorio_id!: FormControl;
    role_id!: FormControl;
    loadingSpinner: boolean = false;
    loadingRoleSpinner: boolean = false;
    loadingEscritorioSpinner: boolean = false;
    listRoles!: IRole[];
    listEscritorios!: IEscritorio[];
    exibeRoles: boolean = true;

    ngOnInit(): void {
        this.name = new FormControl(this.data?.name ?? "");
        this.escritorio_id = new FormControl(this.data?.escritorio_id ?? "");
        this.role_id = new FormControl(this.data?.role_id ?? "");
        this.exibeRoles = this.data.show_roles ?? true;
    }

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltrarUsuariosComponent, { static: false }) table!: FiltrarUsuariosComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltrarUsuariosComponent>,
        public _roleService: RolesService,
        public _escritorioService: EscritorioService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);

        this.getAllRoles();
        this.getAllEscritorios();
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    getAllRoles() {
        this.loadingRoleSpinner = true;
        this._roleService
            .getAll({ no_paginate: true })
            .pipe(finalize(() => (this.loadingRoleSpinner = false)))
            .subscribe(
                (list) => {
                    this.listRoles = list.data;
                },
                (error) => {
                    console.error(error);
                }
            );
    }

    getAllEscritorios() {
        this.loadingEscritorioSpinner = true;
        this._escritorioService
            .getAll({ no_paginate: true })
            .pipe(finalize(() => (this.loadingEscritorioSpinner = false)))
            .subscribe(
                (list) => {
                    this.listEscritorios = list.data;
                },
                (error) => {
                    console.error(error);
                }
            );
    }

    filtrar() {
        this.dialogRef.close({
            name: this.name.value,
            role_id: this.role_id.value,
            escritorio_id: this.escritorio_id.value,
        });
    }
}
